export const natureOptions = ['其他', '民营', '公立']

export const gradeOptions = [
  '三甲',
  '三乙',
  '三丙',
  '二甲',
  '二乙',
  '二丙',
  '一甲',
  '一已',
  '一丙',
  '其他',
]

export const formSections = [
  { key: 'basic', icon: 'el-icon-office-building', label: '基本信息' },
  { key: 'address', icon: 'el-icon-location-outline', label: '地址与联系' },
  { key: 'business', icon: 'el-icon-setting', label: '业务规则' },
  { key: 'ad', icon: 'el-icon-picture-outline', label: '广告配置' },
]
